module.exports = "pegasus_template/assets/column-16-basic.png";